import { render, staticRenderFns } from "./TherapyCard.vue?vue&type=template&id=4ca8ed4d&scoped=true&"
import script from "./TherapyCard.vue?vue&type=script&lang=js&"
export * from "./TherapyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca8ed4d",
  null
  
)

export default component.exports